import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  assignmentList: [],
}

export const getters = {}

export const mutations = {
  CACHE_ASSIGNMENT_LIST(state, newList) {
    state.assignmentList = newList
  },
}

export const actions = {
  // assignment List Service
  fetchAssignmentList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/assignment/?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_ASSIGNMENT_LIST', list)
        return list
      })
  },

  // Get assignment data by Id Service
  getAssignmentDataById({ commit, state, rootState }, assignmentId) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/assignment/${assignmentId}`)
      .then((response) => {
        const assignment = response.data
        return assignment
      })
  },

  // Add assignment Service
  addAssignmentData({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/assignment`, Data)
      .then((response) => {
        const assignment = response.data
        return assignment
      })
  },

  // Update assignment Service
  updateAssignmentData({ commit, state, rootState }, { data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/assignment/${data.id}`, data)
      .then((response) => {
        const assignment = response.data
        return assignment
      })
  },

  deleteAssignmentData({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/assignment/${Data.id}`)
      .then((response) => {
        const assignment = response.data
        return assignment
      })
  },
}
